import React, { useContext } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { authContext } from 'contexts/AuthContext';
import MyDetails from './components/MyDetails';
import MyProfileForm from './components/MyProfileForm';

const Profile = () => {
  const { auth, setAuthData } = useContext(authContext);
  return (
    <>
      <h3 className="mb-4">My Profile</h3>
      <Row>
        <Col sm={4}>
          <Card className="user-profile border-0">
            <MyDetails auth={auth.data} />
          </Card>
        </Col>
        <Col sm={8}>
          <Card className="border-0">
            <CardBody>
              <h5>Edit Profile</h5>
              <MyProfileForm auth={auth.data} setAuthData={setAuthData} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Profile;
